import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-52">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[#0a0a0b]" data-id="element-53" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-54" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-blue-900/10 rounded-full blur-[150px] pointer-events-none" data-id="element-55" />
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay pointer-events-none" data-id="element-56" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-57">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-58">
          {/* Left: Content */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} className="max-w-2xl order-2 lg:order-1" data-id="element-59">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 mb-8" data-id="element-60">
              <span className="w-1.5 h-1.5 rounded-full bg-amber-400" data-id="element-61" />
              <span className="text-xs font-medium tracking-wider text-zinc-300 uppercase" data-id="element-62">
                Emprendedor Digital
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-zinc-100 leading-[1.1] mb-6" data-id="element-63">
              Disciplina.
              <br data-id="element-64" />
              Enfoque.
              <br data-id="element-65" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-66">
                Constancia.
              </span>
            </h1>

            <p className="text-lg md:text-xl text-zinc-400 mb-10 leading-relaxed max-w-xl" data-id="element-67">
              Ayudando a personas a construir oportunidades digitales reales a
              través del marketing de afiliados y el desarrollo de habilidades
              de alto valor.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-68">
              <a href="https://www.skool.com/affiliatewave/about?ref=32124321f1d54df7b2eef01cab5ffbf9" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group flex items-center justify-center gap-2 px-8 py-4 bg-amber-400 text-[#0a0a0b] rounded-full font-semibold hover:bg-amber-300 transition-all shadow-[0_0_20px_rgba(251,191,36,0.15)] hover:shadow-[0_0_30px_rgba(251,191,36,0.25)]" data-id="element-69">
                Comienza Tu Viaje Digital
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-70" />
              </a>
            </div>
          </motion.div>

          {/* Right: Portrait */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1.2,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} className="relative order-1 lg:order-2" data-id="element-71">
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:ml-auto lg:mr-0 rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-72">
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0b] via-transparent to-transparent z-10" data-id="element-73" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0b]/50 via-transparent to-transparent z-10" data-id="element-74" />
              <img src="https://cdn.magicpatterns.com/uploads/vJ1rYBnPJSn5rh4nR5HaXv/Luca_Reyes_P.png" alt="Luca Reyes in modern office" className="w-full h-full object-cover object-center" data-id="element-75" />
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.8
          }} className="absolute -bottom-6 -left-6 lg:left-[-10%] z-20 bg-[#0a0a0b]/90 backdrop-blur-xl border border-white/10 p-4 rounded-xl shadow-2xl flex items-center gap-4" data-id="element-76">
              <div className="w-12 h-12 rounded-full bg-amber-400/10 flex items-center justify-center border border-amber-400/20" data-id="element-77">
                <span className="text-amber-400 font-bold text-lg" data-id="element-78">10+</span>
              </div>
              <div data-id="element-79">
                <p className="text-sm font-bold text-zinc-100" data-id="element-80">
                  Años de Experiencia
                </p>
                <p className="text-xs text-zinc-400" data-id="element-81">
                  Construyendo negocios online
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}